import { UntypedFormGroup } from '@angular/forms';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { EmitType } from '@syncfusion/ej2-base';
import { ChangeDetectorRef, ViewChild, OnInit, Component, Input, Output, EventEmitter, ViewEncapsulation, SimpleChanges } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DeleteFormService } from '../../../shared/services/delete-form.service';
import { StorageManagerService } from '../../../shared/services/storage-manager.service';

@Component({
  selector: 'app-delete-button',
  templateUrl: 'delete-button.component.html',
  styleUrls: ['./delete-button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DeleteButtonComponent implements OnInit {
  settings: any;

  constructor(private cdRef: ChangeDetectorRef, private router: Router, private toastr: ToastrService,
    private deleteService: DeleteFormService, private storageService: StorageManagerService) { }

  @ViewChild('deleteModal') deleteModal: DialogComponent;
  @Input() deleteModalMethod: Function = function () { };
  @Input() formGroup: UntypedFormGroup = null;
  @Input() pageLoading: boolean = false;
  @Input() canDelete: boolean = true;
  @Input() isDelivery: boolean | undefined = false;
  @Output() pageLoadingChange = new EventEmitter<boolean>();
  @Input() isDraft: boolean | undefined;
  @Input() revisionId: string;
  @Input() apiController: string;
  @Input() isSideBar: boolean | undefined = false;

  // Optional inputs
  // Page to redirect to after deleting, ex. 'product-labeling-listing'
  @Input() redirectPage?: string = '';
  @Input() appVariantName?: string = '';


  //Modal for selecting SPL Version
  confirmDialogSelection$: Subject<boolean> = new Subject<boolean>();
  buildModalDialogVisible: boolean;
  sub: Subscription;

  // Modal properties
  position: object = { X: 'center', Y: 'center' };
  // Slightly wider than standard to not hang text
  modalWidth = '32%';
  modalHeight = 'auto';
  animationSettings: Object = { effect: 'Zoom' };
  isModal = true;

  isBaseRevision: boolean;

  ngOnInit() {
    // handle possible undefined
    const isDraft = !!this.isDraft;
    const isDelivery = !!this.isDelivery;

    // prevent isDraft and isDelivery both being TRUE
    this.isDraft = isDraft && !isDelivery;
    this.isDelivery = isDelivery && !isDraft

    this.isBaseRevision = !isDraft && !isDelivery;
  }

  openDeleteModal() {
    // If a revisionId exists, show modal for setting a version and cancel the build if Cancel is seleced.
    if(this.revisionId){
        this.deleteModal.show();
    }
  }

  buildDlgBtnYes: EmitType<object> = () => {
    const modifiedByUser = typeof this.storageService.read('userData') === 'object' ? this.storageService.read('userData')?.name : '';

    this.pageLoading = true;
    this.pageLoadingChange.emit(this.pageLoading);

    this.deleteService.deleteForm(this.revisionId, this.apiController, modifiedByUser, this.appVariantName, this.isDelivery).subscribe((response) => {
      this.pageLoading = false;
      this.pageLoadingChange.emit(this.pageLoading);
      if (response?.isSuccess) {
        this.toastr.success(`Successfully Deleted Form: ${this.revisionId}`);
        if (this.redirectPage) {
          this.router.navigate(['/'.toString() + this.redirectPage]);
        } else {
          this.onFormDeactivatedSuccessful();
        }
      } else {
        this.toastr.error(`${response?.message}`);
      }
    },
      error => {
        this.pageLoading = false;
        this.pageLoadingChange.emit(this.pageLoading);
        this.toastr.error(error && error.errorMessage ? error.errorMessage : error);
      }
    );

    this.deleteModal.hide();
  }

  buildDlgBtnNo: EmitType<object> = () => {

    this.deleteModal.hide();

    return this.confirmDialogSelection$.next(false);
  }

  buildDlgButtons: Object[] = [{ click: this.buildDlgBtnNo.bind(this), buttonModel: { content: 'Cancel' } }, { click: this.buildDlgBtnYes.bind(this), buttonModel: { content: 'Confirm', isPrimary: true } }];

  onFormDeactivatedSuccessful() {
    // force reload page within router to reload data, but not lose toastr messages
    const initialUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([initialUrl]);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    // eslint-disable-next-line guard-for-in
    for (const property in changes) {

        let isDraft = this.isDraft;
        let isDelivery = this.isDelivery;

        if(property === 'isDraft'){
            isDraft = !!changes[property].currentValue;
        }

        if(property === 'isDelivery'){
            isDelivery = !!changes[property].currentValue;
        }

        this.isDraft = isDraft && !isDelivery;
        this.isDelivery = isDelivery && !isDraft;

        this.isBaseRevision = !this.isDraft && !this.isDelivery;
    }
}
}
